var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        title: "Edit Config",
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "padding-lr",
          attrs: { model: _vm.form, rules: _vm.formRules },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "value", label: _vm.label } },
            [
              _vm.isVideoUploadMaximumSize
                ? _c(
                    "div",
                    { staticClass: "video-size-input" },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          "step-strictly": "",
                          step: 10,
                          min: 10,
                          max: 500,
                        },
                        model: {
                          value: _vm.form.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "value", $$v)
                          },
                          expression: "form.value",
                        },
                      }),
                      _c("span", { staticClass: "video-size" }, [_vm._v("MB")]),
                    ],
                    1
                  )
                : _c(
                    "el-input",
                    {
                      attrs: {
                        type: _vm.inputType,
                        rows: 5,
                        placeholder: _vm.placeholder,
                      },
                      model: {
                        value: _vm.form.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "value", $$v)
                        },
                        expression: "form.value",
                      },
                    },
                    [
                      _vm.isPassword
                        ? _c(
                            "span",
                            {
                              attrs: { slot: "suffix" },
                              on: { click: _vm.toggleTypeHandler },
                              slot: "suffix",
                            },
                            [
                              _c("i", {
                                staticClass: "el-input__icon el-icon-view",
                                class: { active: _vm.toggleType },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v(" Save ")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }